import { IsNotEmpty } from 'common/validation/decorators/IsNotEmpty'
import { IsEmail } from 'common/validation/decorators/IsEmail'
import { NotContainsSpace } from 'common/validation/decorators/NotContainsSpace'
import { IsString } from 'common/validation/decorators/IsString'
import { FormModel } from '../../../../../common/form-state-manager/classes/FormModel'

/**
 * VALIDADOR
 * Define validacao dos campos do formulario de RECUPERAR SENHA.
 *
 * @author hjcostabr
 */
export class RecoverPwdFormValidator extends FormModel {

    @NotContainsSpace()
    @IsString()
    @IsNotEmpty()
    schema: string

    @IsEmail()
    @IsNotEmpty()
    email: string

    constructor(initialValues?: Partial<RecoverPwdFormValidator>) {
        super()
        Object.assign(this, initialValues)
    }
}
